import type { ReportField } from "../../../../../../../../../api/types/svTypes.ts";
import PrimaryCaption from "./PrimaryCaption.tsx";

interface Props {
  field: ReportField;
  captionColor?: string;
  caption?: string;
}
export default function MeasureDimensionCaption({ field, captionColor, caption }: Props) {
  const text = caption ?? (field.config.customLabel || field.meta.caption);

  return <PrimaryCaption captionColor={captionColor} text={text} />;
}
